import { clsx } from 'clsx'
import type { SelectHTMLAttributes } from 'react'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: string
}

export function Select({ error, className, children, ...props }: SelectProps) {
  return (
    <div className="w-full">
      <select
        className={clsx(
          'w-full px-3 py-2 rounded-lg border border-coolgray focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent',
          error && 'border-red-500 focus:ring-red-500',
          className
        )}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  )
}
